<script>

import {useVisibility} from "@/composables/useVisibility.js";
import FileInput from "@/components/form/FileInput.vue";

export default {
    components: {FileInput},
    setup() {
        const { showTax, showAutoSettlement } = useVisibility()

        return {
            showTax,
            showAutoSettlement
        }
    },
    data() {
        return {
            errors: [],
            error: false,
            file: null,
            loading: false,
            controller: new AbortController(),
            downloadingSampleFile: false
        }
    },
    methods: {
        submit() {
            this.errors = [];
            this.loading = true;

            let data = new FormData();
            data.append('file', this.file);
            axios.post('/users/employees/import', data, {
                signal: this.controller.signal
            }).then(() => {
                this.$toast.success('Konta pracowników zostały utworzone!');
                this.$router.push({name: 'employees.index'});
            }).catch((data) => {
                this.errors = data.response?.data || [];
            }).finally(() => {
                this.loading = false;
                this.file = null;
            })
        },
        downloadSampleFile() {
            this.downloadingSampleFile = true;
            axios({
                url: '/users/employees/sample-import-file',
                params: {
                    tax_active: this.showTax ? 1 : 0,
                    auto_settlement_active: this.showAutoSettlement ? 1 : 0,
                },
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                saveAs(response.data, 'employees.csv');
            }).finally(() => {
                this.downloadingSampleFile = false;
            });
        }

    },
    mounted() {
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="trainings-create">
        <form @submit.prevent="submit">

            <section class="mb-6 is-flex is-flex-direction-column is-align-items-center">
                <b-field>
                    <FileInput v-model="file"/>
                </b-field>
            </section>

            <section class="block">
                <div class="buttons">
                    <b-button type="is-primary"
                              :loading="loading" :disabled="loading || !this.file"
                              @click.prevent="submit()">
                        {{ $t('actions.send') }}
                    </b-button>
                    <b-button type="is-info"
                              :loading="downloadingSampleFile"
                              :disabled="downloadingSampleFile"
                              icon-left="download"
                              @click.prevent="downloadSampleFile()">
                        {{ $t('actions.download_sample_file') }}
                    </b-button>
                    <b-button @click.prevent="$router.push({name: 'employees.index'})">
                        {{ $t('actions.back') }}
                    </b-button>
                </div>
            </section>

            <section class="block" v-if="errors.length">
                <div v-for="error in errors" class="notification is-danger">
                    <p v-for="messages in error.errors">
                        {{ $t('data.row' )}} {{ error.row }}: {{ messages }}
                    </p>
                </div>
            </section>

        </form>
    </div>
</template>
